import * as React from 'react'
import { Modal, Button, FormControl, Form } from "react-bootstrap";

// advanceFilters: any[]

interface Props {
    show : boolean;
    setShow : Function;
    setFilters: Function;
    columns: any[];
}


class Column {
    id = null;
    operand = '';
    value = '';
    isLike = true;
}

export class AdvancedFilterModal extends React.Component<Props> {

    state = {
        columns: [new Column()]
    }

    submitForm = (e) => {
        e.preventDefault();
        let filters = this.state.columns
            .map((column, index) => {
                column.id = e.target[`name-${index}`].value;
                column.value = e.target[`value-${index}`].value;
                column.operand = e.target[`operand-${index}`].value;
                column.isLike = ('true' === e.target[`like-${index}`].value ? true : false);
                return column;
            })
            .filter(column => {
                if (column.id === "0" || column.value === "") {
                    return false;
                }
                return true
            })
        // console.log(filters)
        this.props.setFilters(filters)
    }

    dropDownItem = (set, id) => {
        return (
            <FormControl
                id={id}
                size="lg"
                as="select"
                defaultValue="0">
                <option disabled value="0">
                    Select a field...
                    </option>
                {set.map((item, key) => {
                    return <option key={key}>{item}</option>
                })}
            </FormControl>
        )
    }

    rows = (set) => {
        if (this.state.columns.length > 0) {

            return this.state.columns.map((_, index) => (
                <div key={index} className="row mt-3">
                    <div className="col-sm-2">
                        {this.dropDownItem(set, `name-${index}`)}
                    </div>
                    <div className="col-sm-6">
                        <FormControl size="lg" id={`value-${index}`} />
                    </div>
                    <div className="col-sm-2">
                        <FormControl
                            size="lg"
                            as="select"
                            id={`operand-${index}`}
                            defaultValue='and'>
                            <option value="and"> And </option>
                            <option value="or"> Or </option>
                        </FormControl>
                    </div>
                    <div className="col-sm-2">
                        <FormControl
                            size="lg"
                            as="select"
                            id={`like-${index}`}
                            defaultValue='AND'>
                            <option value='true'> Like </option>
                            <option value="false"> Equal </option>
                        </FormControl>
                    </div>
                </div>
            ))
        } else {
            return <h4>No filters have been added</h4>
        }
    }

    render() {
        const set = new Set();

        for (let column of this.props.columns) {
            set.add(column.accessor);
        }

        return (
            <Modal size='xl' show={this.props.show} onHide={() =>this.props.setShow()}>
                <Form onSubmit={this.submitForm}>
                    <Modal.Header closeButton>
                        <Modal.Title>Advanced Search</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.rows(Array.from(set))}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ columns: [] })}>
                            Reset
                    </Button>
                        <Button variant="success" onClick={() => this.setState({
                            columns: [...this.state.columns, new Column()]
                        })}>
                            Add Filter <i className="fa fa-plus-circle ml-2"></i>
                        </Button>
                        <Button type='submit' variant="primary" >
                            Search
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    }
}
